import React, { useState, useEffect } from 'react';
import { TextField as MUITextField } from '@mui/material';
import TEXT from './text';
import { useSelector } from 'react-redux';

const BirthdatePickerComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const language = useSelector(state => state.App_Settings.language);

    const [dateValue, setDateValue] = useState(value || options.value || '');

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== dateValue) {
            setDateValue(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;

        if (constrains.maxDate && new Date(newValue) > new Date(constrains.maxDate)) {
            return;
        }

        if (constrains.minDate && new Date(newValue) < new Date(constrains.minDate)) {
            return;
        }

        setDateValue(newValue);

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? newValue.trim() !== '' : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(newValue);
        }
    };

    return (
        <MUITextField
            label={options.label || TEXT.BirthdatePicker[language]}
            adapterLocale="en-gb"
            type="date"
            variant={options.variant || 'outlined'}
            value={dateValue}
            onChange={handleChange}
            format="DD - MM - YYYY"
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            InputLabelProps={{
                shrink: true,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default BirthdatePickerComponent;
